import { FeatureFlagKey } from '../../types/FeatureFlag';
import { AppState } from '../../store/types/Store';
import { SeasonContext, SeasonListItem } from '../../types/Season';
import { buildSeasonContext } from '../../utils/seasonUtils';

export const selectApplicationCardEnabled = (state: AppState): boolean =>
  Boolean(
    state.feature.userConfigFeatures[FeatureFlagKey.DMB_APPLICATION_CARD]?.value,
  );

export const mergeSeasonContexts = (
  primary: SeasonContext[],
  tags: string[],
  seasons: Record<string, SeasonListItem>,
): SeasonContext[] => {
  const merged = new Map<string, SeasonContext>();

  primary.forEach((context) => {
    merged.set(context.seasonTag, context);
  });

  new Set(tags).forEach((seasonTag) => {
    const context = buildSeasonContext(seasonTag, seasons[seasonTag]);
    merged.set(seasonTag, context);
  });

  return Array.from(merged.values());
};
